import { IEventCalculateOptions, IFacilitatedCleansingService } from './PA.FC.Services'
import { IEventCalculateResults } from './EventCalculator'
import { PAEnvironment } from '../PA.Core/PAEnvironment'
import axios from 'axios'

export interface IFacilitatedCleansingRequest {
    requestType:       string,
    wbEventIds?:       number[],
    options?:          any
}

export interface IFacilitatedCleansingResults {
    requestType:       string,
    request:           IFacilitatedCleansingRequest
    results:           IEventCalculateResults | any
}

export class FacilitatedCleansingService
implements IFacilitatedCleansingService
{
    async calculatePendingMetrics(wbEvtIds: number[], opts?: IEventCalculateOptions): Promise<IEventCalculateResults> {
        let fcRslts = await FacilitatedCleansingService.makeRequest({
            requestType: "calculatePendingMetrics",
            wbEventIds: wbEvtIds,
            options: opts || {}
        })
        return fcRslts.results
    }


    //
    private static async makeRequest(request: IFacilitatedCleansingRequest): Promise<IFacilitatedCleansingResults> {

        try {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'facilitatedCleansing';
            else
                sEndPoint += '/facilitatedCleansing';

            let resp = await axios.post(sEndPoint, {data: {request: request}})
            let responseData: IFacilitatedCleansingResults = resp.data;
            return responseData;

        } catch (err: any) {
            throw new Error('Unable to obtain Facilitated Cleansing Results from Server. ' + err);
        }
    }


}